import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminContentFlywheel from "@/pages/AdminContentFlywheel";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/content-flywheel")({
  head: () => seoHead("/admin/content-flywheel"),
  component: () => (
    <StaffAdminGate><AdminContentFlywheel /></StaffAdminGate>
  ),
});
